import { css } from '@/styled-system/css';

export const stack = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const header = css({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 'tighter',
});

export const footerRow = css({
  display: 'flex',
  justifyContent: 'center',
});

// A caller's author-level `display` would otherwise beat the UA's [hidden].
export const gatedContent = css({
  '&[hidden]': { display: 'none' },
});
